// import propertyDialogSetting from "../../../../cli-core/mixins/propertyDialogSetting";
export default {
  mixins: [$mixins.propertyDialogSetting],
  props: {
    // 不配置 url
    noUrl: {
      type: Boolean,
      default: false,
    },
    selectTabsVals: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectTabs() {
      return this.selectTabValues.map((name) => this.tabMap[name]).filter(it=>!!it);
    },
  },
  data() {
    return {
      tabs: [],
      selectTabValues: [],
      loadComplete: false,
      options: {
        animation: 300,
        delay: 100,
        forceFallback: true,
        ghostClass: "ghost",
        dragClass: "drag",
        chosenClass: "drag-chosen",
      },
    };
  },
  created() {
    this.tabMap = {};
    let tabs = [];
    this.currentData.forEach((tab) => {
      this.tabMap[tab.name] = tab;
      tab && tabs.push(tab);
    });
    let selectTabsVals = [];
    this.selectTabsVals.forEach((name) => {
      if (this.tabMap[name] && !this.tabMap[name]?.hide) selectTabsVals.push(name);
    });
    this.tabs = tabs;
    this.selectTabValues = selectTabsVals;
    this.loadScript(() => {
      this.loadComplete = true;
    });
  },
  methods: {
    yes() {
      let realSelectTabsVals = this.selectTabValues;
      if (!realSelectTabsVals.length) {
        realSelectTabsVals = this.tabs
          .filter((item) => !item.hide)
          .map((item) => item.name);
      }
      return realSelectTabsVals;
    },
    reset() {
      this.selectTabValues = this.tabs
        .filter((item) => !item.hide)
        .map((item) => item.name);
      return this.selectTabValues;
    },
    loadScript(callback) {
      if (window.vuedraggable) {
        this.scriptLoaded = true;
        callback?.();
      } else {
        this.$http
          .importFiles([
            dsf.url.getWebPath("$/js/libs/vuedraggable/Sortable-1.13.0.js"),
            dsf.url.getWebPath("$/js/libs/vuedraggable/vuedraggable.umd.js"),
          ])
          .then(() => {
            this.scriptLoaded = true;
            callback?.();
          })
          .catch((err) => {
            console.error(err);
            dsf.layer.message("加载fabric文件报错", false);
          });
      }
    },
    update({ oldIndex, newIndex }) {
      this.swapArray(this.selectTabValues, oldIndex, newIndex);
    },
    swapArray(arr, index1, index2) {
      arr.splice(index2 ,0,...arr.splice(index1,1))
      return arr;
    },
    removeTag(tab, i) {
      this.selectTabValues.splice(i, 1);
    },
  },
  mounted() { },
};
